
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleSizeType, StyleColorSchemeType, StyleFontWeightType } from '@/ui-kit/styles/enums';
import Link from '@/ui-kit/components/link';
import Icon from '@/ui-kit/components/icon';
import routes from '@/constants/routes';
import { track } from '@/utils/analytics';
import ServiceTypes from '../../enums';

export default {
  name: 'ProMarketplaceLandingPageCard',
  components: {
    Icon,
    Typography,
    Link,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    categoryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      StyleFontWeightType,
      TypographyType,
    };
  },
  computed: {
    iconType() {
      switch (this.title) {
        case ServiceTypes.Staging:
          return IconType.Furniture;
        case ServiceTypes.Mortgages:
          return IconType.Renovations;
        case ServiceTypes.Photography:
          return IconType.Camera;
        case ServiceTypes.Measurements:
          return IconType.Measurements;
        case ServiceTypes.Legal:
          return IconType.Legal;
        case ServiceTypes.HomeInspection:
          return IconType.HomeInspection;
        default:
          return IconType.Homes;
      }
    },
    proSearchLink() {
      return `${routes.proSearch}?categoryId=${this.categoryId}`;
    },
  },
  methods: {
    trackCardClick() {
      track(`Find a Pro_${this.title} tile click`);
    },
  },
};
